// extracted by mini-css-extract-plugin
export default {"modal":"AchVerificationModal__modal___XC1_Z"};